import React from 'react';
import { NavLink } from 'react-router-dom';
import { useFitStore } from '../../store/useFitStore';
import { getNavItems, NavIcon, leadsDueCount } from './nav';

const BottomNav: React.FC = () => {
  const { user, leads } = useFitStore();
  if (!user) return null;

  const navItems = getNavItems(user.role);
  const leadsDue = leadsDueCount(leads);

  return (
    <nav className="bottom-nav md:hidden">
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.path === '/coach' || item.path === '/client'}
          className={({ isActive }) => `bottom-nav-link ${isActive ? 'active' : ''}`}
        >
          <span className="relative">
            <NavIcon name={item.icon} className="w-5 h-5" />
            {item.path === '/coach/leads' && leadsDue > 0 && (
              <span className="absolute -top-1 -right-1.5 w-2 h-2 rounded-full bg-white" />
            )}
          </span>
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default BottomNav;
